import "../../../styles/components/home/banner/homePageBannerCardComponent.scss";
export const HomePageBannerCardComponent = ({ props }) => {
  const { image } = props;

  return (
    <div className="homePageBannerCardContainer" style={{ backgroundImage: `url(${image})` }}>
      <div className="overlay"></div>
    </div>
  );
};

export default HomePageBannerCardComponent;
